
/* injects from baggage-loader */

function getAlignment( element, useComputedState ) {
  useComputedState = useComputedState === undefined || useComputedState;

  var align;
  if ( useComputedState )
    align = element.getComputedStyle( 'text-align' );
  else {
    while ( !element.hasAttribute || !( element.hasAttribute( 'align' ) || element.getStyle( 'text-align' ) ) ) {
      var parent = element.getParent();
      if ( !parent )
        break;
      element = parent;
    }
    align = element.getStyle( 'text-align' ) || element.getAttribute( 'align' ) || '';
  }

  // // Sometimes computed values doesn't tell.
  // align && ( align = align.replace( /(?:-(?:moz|webkit)-)?(?:start|auto)/i, '' ) );

  // !align && useComputedState && ( align = element.getComputedStyle( 'direction' ) == 'rtl' ? 'right' : 'left' );
  return align;
}

CKEDITOR.plugins.add( 'alignment', {
  requires: 'richcombo',
  init: function( editor ) {
    var config = editor.config,
        name,
        styles = {},
        values = [],
        names = ['Left/left','Center/center','Right/right','Justify/justify'],
        style = new CKEDITOR.style( config[ 'alignment_style' ] );

    for ( var i = 0; i < names.length; i++ ) {
      var parts = names[ i ];
      if ( parts ) {
        parts = parts.split( '/' );
        var vars = {},name = names[ i ] = parts[ 0 ];
        vars[ 'value' ] = values[ i ] = parts[ 1 ] || name;
        styles[ name ] = new CKEDITOR.style( config[ 'alignment_style' ], vars );
        styles[ name ]._.definition.name = name;
      } else
        names.splice( i--, 1 );
    }

    editor.ui.addRichCombo( 'alignment', {
      label: 'alignment',
      className: 'cke_alignment',
      title: 'alignment',
      modes: { wysiwyg: 1 },
      editorFocus: 1,
      toolbar: 'alignment,' + 10,
      allowedContent: style,
      requiredContent: style,
      panel: {
        css: [ CKEDITOR.skin.getPath( 'editor' ) ].concat( config.contentsCss ),
        multiSelect: false
      },
      init: function() {
        this.allowedContent = {
          'caption div h1 h2 h3 h4 h5 h6 p pre td th li': {
            propertiesOnly: true,
            styles: this.cssClassName ? null : 'text-align',
            classes: this.cssClassName || null
          }
        };
        if ( editor.config.enterMode == CKEDITOR.ENTER_BR )
          this.allowedContent.div = true;

        for ( var i = 0; i < names.length; i++ ) {
          var parts = names[ i ];
          if ( parts ) {
            parts = parts.split( '/' );
            name = names[ i ] = parts[ 0 ];
            value = values[ i ] = parts[ 1 ] || name;
            this.add( name, styles[ name ]._.definition.name ,value );
          }
        }
      },
      onClick: function(value) {
        editor.focus();
        editor.fire("saveSnapshot");
        var selection = editor.getSelection(),
            enterMode = editor.config.enterMode;

        if ( !selection )
          return;

        var bookmarks = selection.createBookmarks(),
          ranges = selection.getRanges();

        var iterator, block;
        var useComputedState = editor.config.useComputedState;
        useComputedState = useComputedState === undefined || useComputedState;

        for ( var i = ranges.length - 1; i >= 0; i-- ) {
          iterator = ranges[ i ].createIterator();
          iterator.enlargeBr = enterMode != CKEDITOR.ENTER_BR;

          while ( ( block = iterator.getNextParagraph( enterMode == CKEDITOR.ENTER_P ? 'p' : 'div' ) ) ) {
            if ( block.isReadOnly() )
              continue;
            getAlignment(block, true)
            block.setStyle( 'text-align', value );
          }

        }

        editor.focus();
        editor.forceNextSelectionCheck();
        selection.selectBookmarks( bookmarks );
        editor.fire("saveSnapshot");
      },
      onRender: function() {
        editor.on("selectionChange", function(b) {
          var currentValue = this.getValue();
          var elementPath = b.data.path,elements = elementPath.elements;
          for ( var i = 0, element; i < elements.length; i++ ) {
            element = elements[ i ];
            for ( var value in styles ) {
              if ( styles[ value ].checkElementMatch( element, true, editor ) ) {
                if ( value != currentValue )
                  this.setValue( value );
                return;
              }
            }
          }
          this.setValue("", 'left')
        }, this)
      },
      refresh: function() {
        editor.activeFilter.check(style) || this.setState(CKEDITOR.TRISTATE_DISABLED)
      }
    });
  }
});


CKEDITOR.config.alignment_style = {
  overrides: [ {
    element: 'alignment', attributes: { 'value': null }
  } ]
};



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/alignment/plugin.js